module.exports = __webpack_public_path__ + "img/api-properties.171a7be6.svg";